import api from './api';
import { Treatment } from '../types';

export const treatmentService = {
  async getAll(category?: string): Promise<Treatment[]> {
    const response = await api.get('/treatments', { params: { category } });
    return response.data;
  },

  async getById(id: string): Promise<Treatment> {
    const response = await api.get(`/treatments/${id}`);
    return response.data;
  },

  async getCategories(): Promise<string[]> {
    const response = await api.get('/treatments/categories');
    return response.data;
  },

  async create(data: Partial<Treatment>): Promise<Treatment> {
    const response = await api.post('/treatments', data);
    return response.data;
  },

  async update(id: string, data: Partial<Treatment>): Promise<Treatment> {
    const response = await api.patch(`/treatments/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/treatments/${id}`);
  },
};
